import { Box } from "@mui/material";

import EncampLogo from "../assets/EncampLogo.svg";
import { StatusChip } from "./StatusChip";

/** Exported so grid sort/export values stay in sync with the chip text. */
export function credentialOwnerLabel(isEncampOwned: boolean): string {
  return isEncampOwned ? "Encamp-owned" : "Customer-owned";
}

/** Who controls a portal login. Only the Encamp case carries the brand tent. */
export function CredentialOwnerChip({ isEncampOwned }: { isEncampOwned: boolean }) {
  return (
    <StatusChip
      color={isEncampOwned ? "info" : "default"}
      label={credentialOwnerLabel(isEncampOwned)}
      icon={
        isEncampOwned ? (
          // The mark's fill is brand Pumpkin inside the asset, so it needs no
          // color styling and stays orange in either scheme.
          <Box component="img" src={EncampLogo} alt="" sx={{ height: 12, width: "auto" }} />
        ) : undefined
      }
      // StatusChip's "default" fill is alpha(white, 0.08) — invisible on a white
      // grid surface — and its label is text.secondary grey.
      sx={isEncampOwned ? undefined : { bgcolor: "action.selected", color: "text.primary" }}
    />
  );
}
